export const LOADING = Symbol('LOADING')
export const LOGIN = Symbol('LOGIN')
export const LOGOUT = Symbol('LOGOUT')
export const AUTHENTICATION_ERROR = Symbol('AUTHENTICATION_ERROR')
